module.exports = __webpack_public_path__ + "static/media/approval_history.597d2fb3.svg";